import { ResolvedSeedRequestsService } from '../../request-creation/services/resolved-seed-requests.module';
import { OriginatingSystem } from '../../shared/services/request.service';
import { CropService } from '../../shared/services/crop.service';
import { PollinationInstructionsComponent } from '../../request-creation/experiment-design/pollination-instructions/pollination-instructions.component';
var ReviewRequestComponent = /** @class */ (function () {
    function ReviewRequestComponent(seedRequestsService, cropService) {
        this.seedRequestsService = seedRequestsService;
        this.cropService = cropService;
        this.showPesticidesAllowedAfterDays = false;
        this.showColdTreatmentInput = false;
        this.showDonorNeeded = false;
        this.PollinationInstructionsComponent = PollinationInstructionsComponent;
        this.seedRequests = this.seedRequestsService.seedRequests;
    }
    Object.defineProperty(ReviewRequestComponent.prototype, "isTnRequest", {
        get: function () {
            return this.request.originatingSystem === OriginatingSystem.MyCE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewRequestComponent.prototype, "isT0Request", {
        get: function () {
            return this.request.originatingSystem === OriginatingSystem.EvEnger;
        },
        enumerable: true,
        configurable: true
    });
    ReviewRequestComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cropService.get(this.request.cropId).subscribe({
            next: function (x) {
                _this.showDonorNeeded = x.isDonorNeeded;
            }
        });
        if (this.request.weeksOfColdTreatment) {
            this.showColdTreatmentInput = true;
        }
        this.showPesticidesAllowedAfterDays = this.request.displayPesticidesAllowedAfterDays;
    };
    ReviewRequestComponent.prototype.hasSprayEvents = function () {
        if (!this.request.treatments) {
            return false;
        }
        return this.request.treatments.some(function (treatment) { return treatment.sprayBoothStudyInstructions.length > 0; });
    };
    ReviewRequestComponent.prototype.getGroupLabel = function (groupIndex) {
        if (!this.request.pollinationInstructions || !this.request.pollinationInstructions.pollinationCategory) {
            return '';
        }
        return PollinationInstructionsComponent.getGroupLabelForCategory(groupIndex, this.request.pollinationInstructions.pollinationCategory);
    };
    ReviewRequestComponent.prototype.shouldHideConjunction = function (groupIndex) {
        if (!this.request.pollinationInstructions || !this.request.pollinationInstructions.pollinationCategory) {
            return false;
        }
        return PollinationInstructionsComponent.shouldHideConjunctionByCategoryName(groupIndex, this.request.pollinationInstructions.pollinationCategory);
    };
    return ReviewRequestComponent;
}());
export { ReviewRequestComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/review-request/review-request.component.ts.pre-build-optimizer.js